import React from "react";
import { getFilePath } from "@/utils/utils";

type Props = {
  img?: string
  message?: string
}

const NotFoundData = ({ img = "searcheFiles.svg", message = "Aucune donnée disponible." }: Props) => {
  return (
    <>
      <div className="flex flex-col space-y-4 items-center justify-center py-24">
        {/*<img src={getFilePath(img)} alt="Not found image" />*/}
        <p className="text-gray-400">
          {message}
        </p>
      </div>
    </>
  );
};

export default NotFoundData;
